import { render, staticRenderFns } from "./IssueAddModal.vue?vue&type=template&id=2d82959c&"
import script from "./IssueAddModal.vue?vue&type=script&lang=js&"
export * from "./IssueAddModal.vue?vue&type=script&lang=js&"
import style0 from "./IssueAddModal.vue?vue&type=style&index=0&id=2d82959c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports